import React, { ReactElement } from 'react';
import {
  FdrInfoSectionWrapper,
  FdrTextContainer,
} from './fdr-blog-overview.styles';

interface IFdrBlogOverviewInfoSectionProps {
  leadText: string;
}

export function FdrBlogOverviewInfoSection({
  leadText,
}: IFdrBlogOverviewInfoSectionProps): ReactElement {
  return (
    <FdrInfoSectionWrapper>
      <FdrTextContainer className="text-container">
        {leadText ? (
          <div
            dangerouslySetInnerHTML={{ __html: leadText }}
            className="lead-text"
          />
        ) : null}
      </FdrTextContainer>
    </FdrInfoSectionWrapper>
  );
}
